import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=dfd1203c&scoped=true&"
import script from "./Pay.js?vue&type=script&lang=js&"
export * from "./Pay.js?vue&type=script&lang=js&"
import style0 from "./Pay.scss?vue&type=style&index=0&id=dfd1203c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd1203c",
  null
  
)

export default component.exports